import type {
  EvaluationOutcome,
  RubricScore,
  SubmissionStatus,
  TargetStatus,
} from '@/features/memorization/types';

/** Ratified target status labels (docs/19's derived status list, in priority order). */
export const TARGET_STATUS_LABELS: Readonly<Record<TargetStatus, string>> = {
  ASSIGNED: 'Ditugaskan',
  IN_PROGRESS: 'Sedang Berjalan',
  SUBMITTED: 'Menunggu Evaluasi',
  PARTIALLY_ACCEPTED: 'Sebagian Diterima',
  NEEDS_REVISION: 'Perlu Perbaikan',
  COMPLETED: 'Selesai',
  CANCELLED: 'Dibatalkan',
  EXPIRED: 'Kedaluwarsa',
};

export const SUBMISSION_STATUS_LABELS: Readonly<Record<SubmissionStatus, string>> = {
  AWAITING_EVALUATION: 'Menunggu Evaluasi',
  EVALUATED: 'Sudah Dievaluasi',
};

export const EVALUATION_OUTCOME_LABELS: Readonly<Record<EvaluationOutcome, string>> = {
  ACCEPTED: 'Diterima',
  NEEDS_REVISION: 'Perlu Perbaikan',
};

/** The ratified 4-level rubric (ADR-021 Decision 1) - never a numeric scale. */
export const RUBRIC_SCORE_LABELS: Readonly<Record<RubricScore, string>> = {
  EXCELLENT: 'Sangat Baik',
  GOOD: 'Baik',
  FAIR: 'Cukup',
  NEEDS_IMPROVEMENT: 'Perlu Ditingkatkan',
};
